import { Alert, Button, MenuItem, Stack, TextField, Typography } from "@mui/material";
import type { MeasurementSystem } from "@bw/shared/api";
import { Page } from "../../../common/components/Page";
import { useDistanceUnits } from "../../../common/hooks/useDistanceUnits";

export function DisplayPreferencesPage() {
  const { measurementSystem, preferences, saving, saveError, setMeasurementSystem } = useDistanceUnits();
  return <Page title="Display preferences" back={{ to: "/me/account", label: "Account" }}><Stack spacing={2} sx={{ maxWidth: 560 }}>
    <Typography color="text.secondary">Choose how distances appear when finding facilities and places to play.</Typography>
    {preferences.isError ? <Alert severity="error" action={<Button size="small" onClick={() => void preferences.refetch()}>Retry</Button>}>Could not load your preferences.</Alert> : null}
    <TextField select label="Measurement system" value={measurementSystem} disabled={preferences.isPending || preferences.isError || saving} onChange={(event) => { void setMeasurementSystem(event.target.value as MeasurementSystem).catch(() => {}); }}>
      <MenuItem value="imperial">Imperial (miles)</MenuItem>
      <MenuItem value="metric">Metric (kilometers)</MenuItem>
    </TextField>
    {saving ? <Typography role="status" variant="body2">Saving…</Typography> : null}
    {saveError ? <Alert severity="error">Could not save your preference. Please try again.</Alert> : null}
  </Stack></Page>;
}
